import React from 'react';

import { Typography } from 'shared';
import {
  isAudio,
  isImage,
  isVideo,
} from 'shared_DEPRECATED/components/File/utils';
import { Attachment } from 'shared_DEPRECATED/types/Attachment';

type ChatFormAttachmentReplyProps = {
  attachments?: Attachment[];
};

export const ChatFormAttachmentReply = ({
  attachments = [],
}: ChatFormAttachmentReplyProps) => {
  const [attachment] = attachments;

  return attachment ? (
    <Typography type="small" color="black" cropped textAlign="start">
      {composeAttachmentLabel(attachment)}
    </Typography>
  ) : null;
};

const CONTENT_TYPE_LABEL_MAPPING = {
  IMAGE: 'Photo',
  VIDEO: 'Video',
  AUDIO: 'Voice message',
  FILE: 'File',
};

const composeAttachmentLabel = ({ contentType }: Attachment) => {
  if (isAudio(contentType)) {
    return `🎤  ${CONTENT_TYPE_LABEL_MAPPING.AUDIO}`;
  }
  if (isImage(contentType)) {
    return `📷  ${CONTENT_TYPE_LABEL_MAPPING.IMAGE}`;
  } else if (isVideo(contentType)) {
    return `📹  ${CONTENT_TYPE_LABEL_MAPPING.VIDEO}`;
  }
  return `📁  ${CONTENT_TYPE_LABEL_MAPPING.FILE}`;
};
